import {SortBloggerProfileTables} from "../types/blogger-profile-tables.types";

export const defaultSortBloggerProfileTables: Array<SortBloggerProfileTables> = [
  {
    key: 'advertisement-controls',
    sort: [ 'recordCalendar.plannedDate,desc', 'id,desc' ]
  },
  {
    key: 'competitors-advertisements',
    sort: [ 'adsRelease,desc', 'id,desc' ]
  },
  {
    key: 'service-ratings',
    sort: [ 'id,desc' ]
  }
]
